import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { paymentway, verifyAPI } from './redux/slice';
import PaymentGateway from './components/gateway';
import { event } from '../../utilities/gtag';

const PaymentPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const paymentStatus = useSelector((state) => state.paymentgateway);

  console.log('Current payment status:', paymentStatus);

  useEffect(() => {
    event({
      action: 'payment_page_visited',
      category: 'Page Visit',
      label: 'User visited Payment Page',
      value: 1
    });
  }, []);

  const onSubmit = () => {
    event({
      action: 'profile_creation', // event name
      category: 'Razorpay Payment',
      label: 'User clicked Pay Now',
      value: 1
    });
    setLoading(true);
    const oldpayload = {
      amount: 5000000,
      productName: 'test',
      customerName: 'lexys',
      customerEmail: 'lexyslabs@lexyslabs.com'
    };

    const payload = {
      amount: oldpayload.amount,
      currency: 'INR',
      //   receipt: 'order_rcpt_11235813',
      trn: crypto.randomUUID(), // Generates a unique receipt ID
      notes: {
        customerName: oldpayload.customerName,
        productName: oldpayload.productName,
        customerEmail: oldpayload.customerEmail
      }
    };

    dispatch(paymentway(payload));
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const openRazorpayCheckout = async () => {
    try {
      console.log('Opening Razorpay checkout...');
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        event({
          action: 'profile_creation',
          category: 'Razorpay SDK',
          label: 'Script load error',
          value: 0
        });
        alert('Razorpay SDK failed to load. Check your internet connection.');
        setLoading(false);
        return;
      }

      console.log('Script loaded successfully');

      const orderDetails = paymentStatus.payment_details;
      console.log('Order details for Razorpay:', orderDetails);

      // Setup Razorpay options
      const options = {
        key: 'rzp_test_8oey15fzuX4stX',
        amount: orderDetails.amount,
        currency: orderDetails.currency,
        name: 'Your Company Name',
        description: `Payment for ${orderDetails.notes.productName}`,
        order_id: orderDetails.id, // This is the Razorpay order ID
        handler: async function (response) {
          console.log('Payment successful', response);
          // Handle successful payment
          const resultAction = await dispatch(verifyAPI(response));
          if (verifyAPI.fulfilled.match(resultAction)) {
            console.log('Payment successful', response);
            // You should verify the payment on your backend here
            event({
              action: 'profile_creation',
              category: 'Razorpay Payment',
              label: 'Payment verified and successful',
              value: orderDetails.amount / 100
            });
            navigate('/success');
          } else {
            event({
              action: 'profile_creation',
              category: 'Razorpay Payment',
              label: 'Backend verification failed',
              value: orderDetails.amount / 100
            });
            console.error('Payment verification failed', resultAction.payload);
            navigate('/failure'); // Navigate to failure page
          }
        },
        prefill: {
          name: orderDetails.notes.customerName,
          email: orderDetails.notes.customerEmail
        },
        theme: {
          color: '#3399cc'
        },
        modal: {
          ondismiss: function () {
            console.log('Modal dismissed');
            event({
              action: 'profile_creation',
              category: 'Razorpay UI modal dismissed',
              label: 'User closed modal before payment',
              value: 0
            });
            setLoading(false);
            navigate('/failure'); // Redirect on failure or dismissal
          }
        }
      };
      console.log('Razorpay options:', options);
      // Initialize and open Razorpay
      event({
        action: 'profile_creation',
        category: 'Razorpay UI',
        label: 'Payment modal launched',
        value: 1
      });
      const razorpay = new window.Razorpay(options);
      razorpay.open();
      console.log('Razorpay modal opened');
    } catch (error) {
      console.error('Error opening Razorpay:', error);
      alert('Something went wrong. Please try again later.');
      setLoading(false);
    }
  };

  // This effect runs when payment status changes
  useEffect(() => {
    console.log('Payment status changed:', paymentStatus);
    if (paymentStatus.success === true && paymentStatus.payment_details) {
      console.log('Successful payment status detected');
      // Open Razorpay when we have a successful order response
      openRazorpayCheckout();
    } else if (paymentStatus.success === false) {
      setLoading(false);
      // Handle payment failure
      alert('Failed to create payment. Please try again.');
    }
  }, [paymentStatus]);

  return (
    <>
      <PaymentGateway onSubmit={onSubmit} loading={loading} />
    </>
  );
};

export default PaymentPage;
